import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./App";
import { BuzzProvider } from "./lib/BuzzProvider";
import { AiPage } from "./pages/AiPage";
import { ChatPage } from "./pages/ChatPage";
import { DebugPage } from "./pages/DebugPage";
import { SettingsPage } from "./pages/SettingsPage";
import { TradingPage } from "./pages/TradingPage";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BuzzProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<AppShell />}>
            <Route index element={<ChatPage />} />
            <Route path="trading" element={<TradingPage />} />
            <Route path="ai" element={<AiPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="debug" element={<DebugPage />} />
            <Route path="workspace" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </BuzzProvider>
  </StrictMode>,
);
